import payment from './payment';
import delivery from './delivery';
import gift from './gift';
import common from './common'

export default {
  delivery,
  payment,
  gift,
  common,
};



// WEBPACK FOOTER //
// ./src/i18n/ja/about/index.js